import '../../assets/components/Loader/Loader.css';//#region lib/components/Loader/Loader.module.css
var e = "_loader_1i4mo_1", t = "_centered_1i4mo_5", n = "_xs_1i4mo_45", r = "_sm_1i4mo_55", i = "_md_1i4mo_65", a = "_lg_1i4mo_75", o = {
	loader: e,
	centered: t,
	xs: n,
	sm: r,
	md: i,
	lg: a
};
//#endregion
export { t as centered, o as default, a as lg, e as loader, i as md, r as sm, n as xs };
